import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PrivatePage, TeamTabs } from "@/components";

/**
 * Displays the team page.
 */
const __default__ = {
  name: "MyTeamView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PrivatePage), { "full-window": "" }, {
    default: _withCtx(() => [
      _createVNode(_unref(TeamTabs))
    ]),
    _: 1
  }))
}
}

})